export enum SectionGroupType {
    unspecfic
}